import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showToast } from '../../../../../components/toast/toastSlice';
import { addAuthorizedDomain } from '../../../../../spots/spotsActions';

class AuthorizedDomains extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: ''
    };
  }

  handleShowToast = (type, message) => {
    const payload = {
      message: message,
      type: type
    };
    this.props.showToast(payload);
  };

  addDomain() {
    var domain = this.state.value;
    const domainPattern = /^(https?:\/\/)?((www\.)?(\*\.)?([a-zA-Z0-9.-]+|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(?::(\d{1,5}))?$/;
    if (!domainPattern.test(domain)) {
      this.handleShowToast('error', 'Please enter a valid domain');
      return;
    }
    this.props.addDomain(domain);

    this.setState({ value: '' });
  }

  handleChange(event) {
    var value = event.target.value;
    this.setState({ value });
  }

  render() {
    return (
      <div className="authorized-domains">
        <div className="field">
          <div className="field-title">Authorized Domains</div>
          <div className="field-description">
            Only domains on this list will be authorized to load your OpenWeb components.
          </div>
          <div className="input-wrapper">
            <div className="text-field-regular authorized-domains-input">
              <input
                ref="inputField"
                type="text"
                value={this.state.value}
                placeholder="Type a URL..."
                onChange={this.handleChange.bind(this)}
              />
            </div>
            <span className="add-button" onClick={this.addDomain.bind(this)}>
              Add
            </span>
          </div>
        </div>
      </div>
    );
  }
}

AuthorizedDomains.propTypes = {
  spotId: PropTypes.string.isRequired,
  showToast: PropTypes.func
};

AuthorizedDomains.displayName = 'AuthorizedDomains';

function mapDispatchToProps(dispatch) {
  return {
    showToast: payload => dispatch(showToast(payload)),
    addDomain: payload => dispatch(addAuthorizedDomain(payload))
  };
}

export default connect(undefined, mapDispatchToProps)(AuthorizedDomains);
